import React, {Component} from 'react';
import '../assets/apps.css';
import Helpers from '../Shared/Helpers';
import REST from '../Shared/REST';
import {withRouter} from 'react-router-dom';
import {clearInterval, setInterval} from "timers";
import {Buttons, Buttons1, CountDownComponent, VideoComponent} from "./Common";
import {Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import ProgressBox from "../ProgressModalComponent/ProgressBox";
import "../assets/students/WordMark.css";
import videoInstructionPN from "../assets/images/video_instructions.png";
import InstructionModals from "../Shared/InstructionModals";
import TRACKING from "../Shared/DataTrackingPoints";
import DialogBox from "../Shared/DialogBox";
import {updateAppStates, updateStudentAccountTab, updateStudentAppsStatus} from "./actions";
import connect from "react-redux/es/connect/connect";

let seconds = 0;
let minutes = 0;
let secs = 0;
let resultTime = '';

const tooltipStartTyping = (
    <Tooltip id="tooltipStartTyping">
        Start Typing!
    </Tooltip>
);
class WordMarkComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            passages: [],
            loadedScores: false,
            bestScores:{
                wordmarkScore:1,
                wordmarkLevel:1
            }
        };
        this.handleActive = this.handleActive.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
    }

    async componentDidMount() {
        await Helpers.authorize(this);
        await REST.getBestScores().then(async(response) => {
            if (response.success) {
                await this.setState({
                    loadedScores: true,
                    bestScores:response.body
                });
            }
        });
        await REST.getWordMarkRandom().then(async(response) => {
            if (response.success) {
                await this.setState({passages: response.body});
            } else {
                console.log('WordMark Error', response);
            }
        }, (error) => {
            console.log('WordMark Error', error);
        });
    }

    handleActive = (active) => {
        this.setState({active: active});
    };

    handleSurveyBack(){
        this.props.history.goBack();
    }
    render() {
        return (
            <div className={this.state.active !==2 ? "bgGrey WordMarkContainer" : "bgYellow WordMarkContainer"}>
                {
                    this.state.active === -1 ?
                        <div>
                            <div className="section appSection bgGrey">
                                <div className="container">
                                    <div className="appContainer wordmark">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>WordMark</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 text-center"}>
                                                {
                                                    this.state.loadedScores ?
                                                    <ProgressBox
                                                        level={this.state.bestScores.wordmarkLevel}
                                                        step={this.state.bestScores.wordmarkScore}
                                                        steps={6}
                                                        maxLevel={12}
                                                    /> : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }
                {
                   this.state.active === 0  ?
                        <div>
                            <div className="section appSection bgGrey">
                                <div className="container">
                                    <div className="appContainer wordmark">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>WordMark</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 centerBlock"}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 1  ?
                        <div>
                            <div className={"appSection bgGrey"}>
                                <div className="container">
                                    <Buttons1 demo appName={"wordmark"} practice buttonClick={this.handleActive} currentTabActive={this.state.active} />
                                    <div className="appContainer wordmark">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>WordMark: Show Me</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 centerBlock"}>
                                                <VideoComponent url={"https://s3.us-east-2.amazonaws.com/uploaddev/video/wordmark/wordmark_trimmed.mp4"}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons demo appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 2 ?
                        <div>
                            <Buttons1 practice appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                            <Tutorial studentUser={this.props.studentUser} buttonClick={this.handleActive} passage={this.state.passages[0]} beginTest={this.handleBeginTest}/>
                            <Buttons appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 3 ?
                        <div>
                            <Buttons1 appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                            <WordMarkContent studentUser={this.props.studentUser} handleSurveyBack={this.handleSurveyBack} buttonClick={this.handleActive} passages={this.state.passages}/>
                            <Buttons appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }
            </div>
        )
    }
}

class Tutorial extends Component {

    constructor(props) {
        super(props);
        this.state = {passage: this.props.passage};
    }

    render() {
        let passages = [];
        passages.push(this.props.passage);
        return (
            <WordMarkContent studentUser={this.props.studentUser} buttonClick={this.props.buttonClick} passages={passages} practice={true}/>
        );
    }
}

class WordMarkContent extends Component {
    constructor(props) {
        super(props);
        this.random = this.random.bind(this);
        this.state = {
            popupSurvey: false,
            passages: this.props.passages,
            passage: this.props.passages[this.random()],
            hint: `Read the story starter above. \nIf you like it click 'Begin'.\nIf you do not like it click 'Change'\nYou have one minute to think about your story.\nYou will have three minutes to type your story.`,
            started: false,
            story: '',
            time: 60,
            finished: false,
            sessionTime: 60,
            modalInstruction:false
        };
        this.timer = 0;
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleChangeStory = this.handleChangeStory.bind(this);
        this.handleBegin = this.handleBegin.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleToggleInstruction = this.handleToggleInstruction.bind(this);
        this.onUnload = this.onUnload.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    onUnload(event) { // the method that will be used for both add and remove event
        event.returnValue = "By leaving or reloading the page you will lose your app progress"
    }

    async componentDidMount() {
        window.addEventListener("beforeunload", this.onUnload);
        await this.setState({
            modalInstruction: true
        });

        if(this.state.modalInstruction) {
           await this.setState({story: this.state.passage.storyStarter.replace('...', ' ')}, () => {
                this.startTimer();
            });
        }
        await this.setState({
            analytics: {
                type: TRACKING.STUDENT_WM_START,
                metadata: {}
            }
        })
        this.handleAnalytics();
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onUnload);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleToggleInstruction= (toggleInstruction) => {
        localStorage.setItem('WordmarkInstruction', toggleInstruction);
    }

    startTimer() {
        this.timer = setInterval(this.countDown, 1000);
    }

    countDown() {
        seconds = this.state.time - 1;
        minutes = parseInt(seconds / 60, 10);
        secs = parseInt(seconds % 60, 10);
        if(minutes > 0){
            if(minutes === 2 && secs === 59){
                resultTime = '3 minutes left';
                if(resultTime !== '') {
                    setTimeout(
                        function() {
                            resultTime = '';
                        }
                            .bind(this), 5000);
                }
            }
            if(minutes === 1 && secs === 59){
                resultTime = '2 minutes left';
                if(resultTime !== '') {
                    setTimeout(
                        function() {
                            resultTime = '';
                        }
                            .bind(this), 5000);
                }
            }
        }
        else {
            if(minutes === 0 && secs === 59){
                resultTime = '1 minute left';
                if(resultTime !== '') {
                    setTimeout(
                        function() {
                            resultTime = '';
                        }
                            .bind(this), 5000);
                }
            }
            if(secs === 30){
                resultTime = '30 seconds left';
                if(resultTime !== '') {
                    setTimeout(
                        function() {
                            resultTime = '';
                        }
                            .bind(this), 5000);
                }
            }
            if(secs <= 15){
                resultTime = secs + ' seconds left'
            }
        }
        this.setState({time: seconds});
        if (seconds === 0) {
            if (!this.state.started) {
                this.setState({time: 180, sessionTime: 180, started: true, modalInstruction:false});
            } else {
                clearInterval(this.timer);
                this.handleSave();
            }
        }
    }

    random() {
        const min = 1;
        let max = this.props.passages.length;
        return Math.floor((min + Math.random() * (max - min)) - 1);
    }

    handleTextChange(e) {
        this.setState({story: e.target.value}, () => {
            console.log(this.state.story);
        });
    }

    handleChangeStory(e) {
        this.setState({passage: this.state.passages[this.random()], time: 60}, () => {
            this.setState({story: this.state.passage.storyStarter.replace('...', '')});
        });
    }

    handleBegin(e) {
        this.setState({started: true, time: 180, sessionTime: 180});
    }

    handleSave(e) {
        this.setState({started: false, finished: true});
        if(!this.props.practice) {
            window.removeEventListener("beforeunload", this.onUnload);
            this.saveStory();
        }
        if(this.props.practice){
            this.props.buttonClick(0);
        }
        // e.preventDefault();
    }

    saveStory() {
        let storyStarter = this.state.passage.storyStarter.replace('...', '');
        let fullStory = this.state.story;
        let savedStory = fullStory.replace(storyStarter,"");
        let body = {
            storyStarterId: this.state.passage.id,
            studentResponse: savedStory,
            guid: ""
        };
        REST.postWordMarkSession(body).then((response) => {
            console.log('Response', response);
        }, (error) => {
            console.log('Response Error', error);
        });
    }

    handleClose(e) {
        this.setState({finished: false, popupSurvey: true});
    }

    async handleSurveyBack(){
        this.props.handleSurveyBack();
    }

    prepareHint() {
        let {time, hint} = this.state;
        let regex = /\n/g;
        let h = hint.split(regex);
        let t = '';
        if (time <= 60 && time >= 57) {
            t = h[0];
        } else if (time < 57 && time >= 54) {
            t = t.concat(h[0]).concat('\n').concat(h[1]);
        } else if (time < 54 && time >= 51) {
            t = t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]);
        } else if (time < 51 && time >= 48) {
            t = t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]).concat('\n').concat(h[3]);
        } else {
            t = t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]).concat('\n').concat(h[3]).concat('\n').concat(h[4]);
        }
        return t;
    }

    render() {
        let hint = this.prepareHint();
        let response = '';
        if (this.state.story.length <= this.state.passage.storyStarter.length) {
            response = 'There is nothing to score';
        }
        else {
            response = 'Your story was sent to your teacher';
        }

        return (
            <div>
                <div className={!this.props.practice ? "appSection bgGrey" : "appSection bgYellow"}>
                    <DialogBox surveyModal app={'WordMark'} userId={this.props.studentUser.id} active={this.state.popupSurvey} surveyBack={this.handleSurveyBack}/>
                    <div className="container">
                        <InstructionModals
                            WordMark
                            modalOpen={this.state.modalInstruction}
                            instructionMask={videoInstructionPN}
                            toggleInstruction={this.handleToggleInstruction}
                            starterTitle={this.state.passage.storyStarter}
                            time={this.state.time}
                            sessionTime={this.state.sessionTime}
                            beginClick={(active)=>{this.setState({modalInstruction:false,story: this.state.passage.storyStarter.replace('...', ' ')}); this.handleBegin()}}
                            buttonClick={this.props.buttonClick}
                            changeClick={(active)=>{this.handleChangeStory(); console.log('Change Story!')}}
                            closeClick={(active)=>{this.setState({modalInstruction: active,story: this.state.passage.storyStarter.replace('...', ' ') }); this.startTimer();}}
                        />
                        <div className="row">
                            <div className="passage tc">
                                {this.state.started ?
                                    <OverlayTrigger placement="top"  overlay={tooltipStartTyping}>
                                    <textarea ref={(input) => input && input.focus()}  style={{marginTop:15}} className={"wordmark1"} spellCheck={false} value={this.state.story} onChange={this.handleTextChange}/>
                                    </OverlayTrigger>
                                    :
                                    null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="divBottomRelative tc">
                                <div className={"row tc"}>
                                    <div className={"col-md-4"}></div>
                                    <div className={"col-md-4"}>
                                        {this.state.started ?
                                            <a onClick={this.handleSave} className="handBtn hidden">
                                                <span>Save</span>
                                            </a>
                                            :
                                            null
                                        }
                                    </div>
                                    <div className={"col-md-4"}>
                                        <div className={"row pull-right"}>
                                            {
                                                this.state.started ?
                                                <div>
                                                    <div style={{display:'inline-block',position:'relative',fontFamily:'mainFont',fontStyle:'sans-serif',fontSize:'1.5em',top:-60}}>{resultTime}</div>
                                                    <div className={resultTime ==='' ? "hidden": ""} style={{display:'inline-block'}}><CountDownComponent time={this.state.time} sessionTime={this.state.sessionTime} showTime={this.state.sessionTime}/></div>
                                                </div>
                                                :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal id={"resultBox"} show={this.state.finished && !this.props.practice}>
                    <div className="modal-content">
                        <div className={"row modal-body"} >
                            {/*<span style={{cursor: "pointer"}} onClick={this.closeModal}><img*/}
                            {/*style={{width: 50, marginTop: 25, float: 'right'}} src={closeModalIcon}/></span>*/}
                            <div className="section">
                                <h1 style={{marginBottom:25,fontSize:35}}>Finished</h1>
                                <p>{response}</p>
                                <a className="handBtn" style={{marginTop:15}} onClick={this.handleClose}>
                                    <span>Close</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const bindActionToProps = dispatch => {
    return {
        updateStudentAppStatus: async(results) => await dispatch(updateStudentAppsStatus(results)),
        updateStudentAccountTab:async(tabNum) => await dispatch(updateStudentAccountTab(tabNum)),
        updateAppStates:async(appStates) => await dispatch(updateAppStates(appStates))
    };
};

const mapStateToProps = state => ({
    apps:state.studentReducer.apps,
    tabNum: state.studentReducer.tabNum,
    studentUser: state.studentReducer.studentUser,
    appStates: state.studentReducer.appStates
});

export default connect(mapStateToProps,bindActionToProps)(withRouter(WordMarkComponent));





// WEBPACK FOOTER //
// ./src/StudentsComponent/WordMark.js